import React, { useEffect, useState } from 'react';
import Popover from '@mui/material/Popover';
import { KeyWordHover } from '../Models/content-types/keyword_hover';
import { getKontent } from '../API/KontentAPI';
import DOMPurify from 'dompurify';

interface KeywordHoverProps {
  keyterm?: string | undefined;
  def?: string | undefined;
  linkId: string;
}

const KeywordHover: React.FC<KeywordHoverProps> = props => {
  // ====== START DEFINITIONS
  const [theKeywordHover, setKeywordHover] = useState<KeyWordHover>();
  useEffect(() => {
    const fetchKeywordHover = async (): Promise<void> => {
      try {
        const theKeywordHoverResponse = await getKontent(
          'system.id',
          props.linkId!,
        );
        setKeywordHover(
          theKeywordHoverResponse?.data?.items[0] as KeyWordHover,
        );
      } catch (error) {
        console.error('Error fetching term:', error);
      }
    };
    fetchKeywordHover();
  }, [props.linkId]);

  //popover definitions
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  // ======  END DFINITIONS

  if (!props.keyterm && !props.linkId) {
    return null;
  }

  return (
    <span>
      <span
        onClick={handleClick}
        onMouseOver={handleClick}
        className="keyword"
        data-original-title={theKeywordHover?.elements.content?.value}
        data-placement="top"
        data-toggle="tooltip"
      >
        {props.keyterm || theKeywordHover?.elements.keyterm?.value}
      </span>

      <Popover
        className="tooltip fade top in"
        id={props.linkId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <div className="tooltip-inner">
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                theKeywordHover?.elements.content?.value || '',
              ),
            }}
          />
        </div>
      </Popover>
    </span>
  );
};

export default KeywordHover;
